import { render, staticRenderFns } from "./proxy-datacenter.vue?vue&type=template&id=5daf86c3&"
import script from "./proxy-datacenter.vue?vue&type=script&lang=js&"
export * from "./proxy-datacenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports